// extracted by mini-css-extract-plugin
module.exports = {"accordionItemHeader":"styles_accordionItemHeader__122iO","icon":"styles_icon__3ufej"};